import React from "react"
import {  Link } from 'react-router-dom'
import config from 'react-global-configuration';
import styles from '../styles/top.css'

import HeaderAll from './parts/HeaderAll'
/*
var getInvoiceState = () => {
  return InvoiceStore.getAll()
}
*/

export default class TopApp extends React.Component {

  constructor(){
    super()
    this.photos =  config.get("PHOTOS")
    const photos_rid = Math.floor( Math.random() * this.photos.length );
    this.main_photo = this.photos[photos_rid]
    this.state = {
      item:null
    }
  }

  componentDidMount(){

  }

  componentWillUnmount(){

  }

  /* Handlers */


  render(){
    // return
    const images = this.photos.map((file_name)=>{
      return   <div className="imgbox"><img src={`${process.env.PUBLIC_URL}/images/photo/` + file_name} alt="" /></div>
    })
    return(
      <div>
      <HeaderAll />
      <main>
        <div className="main-pannel top">
          <section className="main-photo">
            <img src={`${process.env.PUBLIC_URL}/images/photo/` + this.main_photo} alt="メイン画像" />
          </section>
          <section className="main-text">
            <p className="big">葉山の大人の週末部活。</p>
            <p>
              葉山でもっと遊びたい！　<br/>葉山でもっとTHE HOUSE で遊びたい！<br/>THE HOUSEの遊び場クラブ、始まりました！
            </p>
          </section>
        </div>
        <div className="main-pannel">
          <section className="text-only">
            <p>THE HOUSE CLUBは<a href="http://thehousehayama.com/" target="_blank">THE HOUSE on the beach</a>を拠点に活動する、会員制のクラブです。</p>
            <p>SUP、Yogaなどのアクティビティを中心に、様々なイベントを定期的に開催しています。</p>
            <p>入会方法などは、<Link to="/club">こちら</Link>をご覧ください。</p>
            <p>現在活動中のアクティビティーは SUP・Yoga・ロースイーツ教室です。</p>
            <p className="top-photo">{images}</p>
          </section>
        </div>
      </main>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/TopApp.js